import { DatePicker } from "antd";
import { CaretDownFilled, CaretUpOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useMerchant } from "../../context/merchantContext";

const SearchDatePickerIncome = ({ title, fieldName }) => {
  const { searchFieldsIncome, setSearchFieldsIncome, showFilter } =
    useMerchant();
  const valueChange = (e) => {
    var query = { ...searchFieldsIncome };
    if (e == null) {
      query[fieldName] = null;
      return setSearchFieldsIncome(query);
    }
    if (!e || e.length !== 2) return;

    var dates = [dayjs(e[0]).startOf("day"), dayjs(e[1]).endOf("day")];
    query[fieldName] = dates;
    setSearchFieldsIncome(query);
  };
  const sortChange = (sort) => {
    setSearchFieldsIncome({
      ...searchFieldsIncome,
      sort: sort,
      sortField: fieldName,
    });
  };
  return (
    <div key={fieldName}>
      <div className="titleWithSort">
        <span style={{ fontSize: 12 }}>{title}</span>
        <div className="sortIcons">
          <CaretUpOutlined
            className="sortIcon"
            style={{ color: "#46CE7C" }}
            onClick={() => sortChange("asc")}
          />
          <CaretDownFilled
            className="sortIcon"
            style={{ color: "#46CE7C" }}
            onClick={() => sortChange("desc")}
          />
        </div>
      </div>
      {showFilter && (
        <>
          <div className="line" />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <DatePicker.RangePicker
              size="small"
              style={{ width: "80%" }}
              placeholder="Хайх утга"
              value={searchFieldsIncome && searchFieldsIncome[fieldName]}
              onChange={valueChange}
            />
          </div>
        </>
      )}
    </div>
  );
};
export default SearchDatePickerIncome;
